import {Action, ActionReducerMap} from '@ngrx/store';
import {DatumGruppeMitteilungen, Funktionsbereich, VeranstaltungBerechtigung, VeranstaltungMitteilungBerechtigung, VeranstaltungMitteilungsVorlage} from '../../../../clients/veranstaltungen';
import {APP_RESET_ACTION} from '@orga-app/appstart/actions';
import {
    GET_MITTEILUNGEN_GESENDET_GRUPPIERT,
    GET_MITTEILUNGEN_GESENDET_GRUPPIERT_ERFOLGREICH,
    GET_MITTEILUNGEN_GESENDET_GRUPPIERT_FEHLER,
    GET_MITTEILUNGEN_GRUPPIERT,
    GET_MITTEILUNGEN_GRUPPIERT_ERFOLGREICH,
    GET_MITTEILUNGEN_GRUPPIERT_FEHLER, GET_VERANSTALTUNG_BERECHTIGUNG_ERFOLGREICH, GET_VERANSTALTUNG_BERECHTIGUNG_FEHLER, GET_VERANSTALTUNG_FUNKTIONSBEREICHE, GET_VERANSTALTUNG_FUNKTIONSBEREICHE_ERFOLGREICH, GET_VERANSTALTUNG_FUNKTIONSBEREICHE_FEHLER,
    GET_VERANSTALTUNG_MITTEILUNG_BERECHTIGUNG, GET_VERANSTALTUNG_MITTEILUNG_BERECHTIGUNG_ERFOLGREICH, GET_VERANSTALTUNG_MITTEILUNG_BERECHTIGUNG_FEHLER, GET_VERANSTALTUNG_MITTEILUNGS_VORLAGEN, GET_VERANSTALTUNG_MITTEILUNGS_VORLAGEN_ERFOLGREICH, GET_VERANSTALTUNG_MITTEILUNGS_VORLAGEN_FEHLER,
    GetMitteilungenGesendetGruppiertErfolgreichAction,
    GetMitteilungenGesendetGruppiertFehlerAction,
    GetMitteilungenGruppiertErfolgreichAction,
    GetMitteilungenGruppiertFehlerAction, GetVeranstaltungBerechtigungErfolgreichAction, GetVeranstaltungFunktionsbereicheAction, GetVeranstaltungFunktionsbereicheErfolgreichAction, GetVeranstaltungFunktionsbereicheFehlerAction, GetVeranstaltungMitteilungBerechtigungErfolgreichAction, GetVeranstaltungMitteilungsVorlagenErfolgreichAction, GetVeranstaltungStatusFehlerAction
} from '../../../../client-ngrx/veranstaltungen';

export interface ModuleState {
    page: PageState;
}

export const reducers: ActionReducerMap<ModuleState> = {
    page: pageReducer
};

export interface PageState {
    // Mitteilungen
    mitteilungenListe: Array<DatumGruppeMitteilungen>;
    uiZeigeMitteilungenLaden: boolean;
    uiZeigeMitteilungenLadefehler: boolean;
    uiZeigeMitteilungSenden: boolean;
    uiZeigeMitteilungSendefehler: boolean;

    mitteilungenGesendetListe: Array<DatumGruppeMitteilungen>;
    uiZeigeMitteilungenGesendetLaden: boolean;
    uiZeigeMitteilungenGesendetLadefehler: boolean;

    veranstaltungMitteilungBerechtigung: VeranstaltungMitteilungBerechtigung | null;
    veranstaltungMitteilungBerechtigungLaden: boolean;
    veranstaltungMitteilungBerechtigungFehler: boolean;

    uiZeigeFunktionsbereicheLaden: boolean;
    uiZeigeFunktionsbereicheLadefehler: boolean;
    uiFunktionsbereicheZurAuswahlListe: Array<Funktionsbereich>;
    veranstaltungBerechtigung: VeranstaltungBerechtigung;

    mitteilungsVorlagen: Array<VeranstaltungMitteilungsVorlage>;
    mitteilungsVorlagenLaden: boolean;
    mitteilungsVorlagenFehler: boolean;


}

export const initialPageState: PageState = {
    mitteilungenListe: [],
    uiZeigeMitteilungenLaden: false,
    uiZeigeMitteilungenLadefehler: false,
    uiZeigeMitteilungSenden: false,
    uiZeigeMitteilungSendefehler: false,

    mitteilungenGesendetListe: [],
    uiZeigeMitteilungenGesendetLaden: false,
    uiZeigeMitteilungenGesendetLadefehler: false,

    veranstaltungMitteilungBerechtigung: null,
    veranstaltungMitteilungBerechtigungLaden: false,
    veranstaltungMitteilungBerechtigungFehler: false,

    uiZeigeFunktionsbereicheLaden: false,
    uiZeigeFunktionsbereicheLadefehler: false,
    uiFunktionsbereicheZurAuswahlListe: [],
    veranstaltungBerechtigung: null,

    mitteilungsVorlagen: [],
    mitteilungsVorlagenLaden: false,
    mitteilungsVorlagenFehler: false
};

export function pageReducer(state = initialPageState, action: Action): PageState {
    switch (action.type) {
        // APP RESET
        case APP_RESET_ACTION: {
            return Object.assign({}, state, <PageState>initialPageState);
        }

        // Mitteilungen - liste
        case GET_MITTEILUNGEN_GRUPPIERT: {
            return Object.assign({}, state, <PageState>{
                uiZeigeMitteilungenLaden: true
            });
        }

        case GET_MITTEILUNGEN_GRUPPIERT_ERFOLGREICH: {
            const a = <GetMitteilungenGruppiertErfolgreichAction>action;

            return Object.assign({}, state, <PageState>{
                mitteilungenListe: a.payload,
                uiZeigeMitteilungenLaden: false,
                uiZeigeMitteilungenLadefehler: false
            });
        }

        case GET_MITTEILUNGEN_GRUPPIERT_FEHLER: {
            const a = <GetMitteilungenGruppiertFehlerAction>action;

            return Object.assign({}, state, <PageState>{
                mitteilungenListe: [],
                uiZeigeMitteilungenLaden: false,
                uiZeigeMitteilungenLadefehler: true
            });
        }

        // Mitteilungen - gesendete liste
        case GET_MITTEILUNGEN_GESENDET_GRUPPIERT: {
            return Object.assign({}, state, <PageState>{
                uiZeigeMitteilungenGesendetLaden: true
            });
        }

        case GET_MITTEILUNGEN_GESENDET_GRUPPIERT_ERFOLGREICH: {
            const a = <GetMitteilungenGesendetGruppiertErfolgreichAction>action;

            return Object.assign({}, state, <PageState>{
                mitteilungenGesendetListe: a.payload,
                uiZeigeMitteilungenGesendetLaden: false,
                uiZeigeMitteilungenGesendetLadefehler: false
            });
        }

        case GET_MITTEILUNGEN_GESENDET_GRUPPIERT_FEHLER: {
            const a = <GetMitteilungenGesendetGruppiertFehlerAction>action;

            return Object.assign({}, state, <PageState>{
                mitteilungenGesendetListe: [],
                uiZeigeMitteilungenGesendetLaden: false,
                uiZeigeMitteilungenGesendetLadefehler: true
            });
        }

        // AKTUELLE VERANSTALTUNGEN MITTEILUNG BERECHTIGUNGEN
        case GET_VERANSTALTUNG_MITTEILUNG_BERECHTIGUNG: {
            return Object.assign({}, state, <PageState>{
                veranstaltungMitteilungBerechtigungLaden: true
            });
        }

        case GET_VERANSTALTUNG_MITTEILUNG_BERECHTIGUNG_ERFOLGREICH: {
            const a = <GetVeranstaltungMitteilungBerechtigungErfolgreichAction>action;

            return Object.assign({}, state, <PageState>{
                veranstaltungMitteilungBerechtigung: a.payload,
                veranstaltungMitteilungBerechtigungLaden: false,
                veranstaltungMitteilungBerechtigungFehler: false
            });
        }

        case GET_VERANSTALTUNG_MITTEILUNG_BERECHTIGUNG_FEHLER: {
            const a = <GetVeranstaltungStatusFehlerAction>action;

            return Object.assign({}, state, <PageState>{
                veranstaltungMitteilungBerechtigung: null,
                veranstaltungMitteilungBerechtigungLaden: false,
                veranstaltungMitteilungBerechtigungFehler: true
            });
        }

        // Funktionsbereiche
        case GET_VERANSTALTUNG_FUNKTIONSBEREICHE: {
            const a = <GetVeranstaltungFunktionsbereicheAction>action;
            return Object.assign({}, state, <PageState>{
                uiZeigeFunktionsbereicheLaden: true
            });
        }
        case GET_VERANSTALTUNG_FUNKTIONSBEREICHE_ERFOLGREICH: {
            const a = <GetVeranstaltungFunktionsbereicheErfolgreichAction>action;

            return Object.assign({}, state, <PageState>{
                uiFunktionsbereicheZurAuswahlListe: a.payload,
                uiZeigeFunktionsbereicheLaden: false,
                uiZeigeFunktionsbereicheLadefehler: false
            });
        }
        case GET_VERANSTALTUNG_FUNKTIONSBEREICHE_FEHLER: {
            const a = <GetVeranstaltungFunktionsbereicheFehlerAction>action;

            return Object.assign({}, state, <PageState>{
                uiFunktionsbereicheZurAuswahlListe: [],
                uiZeigeFunktionsbereicheLaden: false,
                uiZeigeFunktionsbereicheLadefehler: true
            });
        }

        // Berechtigungen der Veranstaltung laden
        case GET_VERANSTALTUNG_BERECHTIGUNG_ERFOLGREICH: {
            const a = <GetVeranstaltungBerechtigungErfolgreichAction>action;

            return Object.assign({}, state, <PageState>{
                veranstaltungBerechtigung: a.payload
            });
        }

        case GET_VERANSTALTUNG_BERECHTIGUNG_FEHLER: {

            // Todo: Veranstaltung_id in VeranstaltungBerechtigung setzen!?
            return Object.assign({}, state, <PageState>{
                veranstaltungBerechtigung: <VeranstaltungBerechtigung>{
                    benutzer_ist_veranstaltungsleiter: false
                }
            });
        }

        // Mitteilungsvorlagen
        case GET_VERANSTALTUNG_MITTEILUNGS_VORLAGEN: {
            return Object.assign({}, state, <PageState> {
                mitteilungsVorlagenLaden: true,
                mitteilungsVorlagenFehler: false
            });
        }
        case GET_VERANSTALTUNG_MITTEILUNGS_VORLAGEN_ERFOLGREICH: {
            const a = <GetVeranstaltungMitteilungsVorlagenErfolgreichAction> action;

            return Object.assign({}, state, <PageState> {
                mitteilungsVorlagen: a.payload,
                mitteilungsVorlagenLaden: false,
                mitteilungsVorlagenFehler: false
            });
        }
        case GET_VERANSTALTUNG_MITTEILUNGS_VORLAGEN_FEHLER: {
            return Object.assign({}, state, <PageState> {
                mitteilungsVorlagenLaden: false,
                mitteilungsVorlagenFehler: true
            });
        }

        default: {
            return state;
        }
    }
}
